import type { AlertButton } from 'react-native'
import { Alert, Platform } from 'react-native'

function webAlert(
  title?: string,
  message?: string,
  buttons?: AlertButton[],
): void {
  if (typeof window === 'undefined') return

  const text = [title, message].filter(Boolean).join('\n\n')

  if (!buttons || buttons.length === 0) {
    window.alert(text)
    return
  }

  const cancelButton = buttons.find((b) => b.style === 'cancel')
  const actionButtons = buttons.filter((b) => b.style !== 'cancel')

  if (actionButtons.length === 1) {
    const confirmed = window.confirm(text)
    if (confirmed) {
      actionButtons[0].onPress?.()
    } else {
      cancelButton?.onPress?.()
    }
    return
  }

  if (actionButtons.length === 0) {
    window.alert(text)
    cancelButton?.onPress?.()
    return
  }

  window.alert(text)
}

export function showAlert(
  title?: string,
  message?: string,
  buttons?: AlertButton[],
): void {
  if (Platform.OS === 'web') {
    webAlert(title, message, buttons)
  } else {
    Alert.alert(title ?? '', message, buttons)
  }
}
